import { render, staticRenderFns } from "./TabMedicalReform.vue?vue&type=template&id=1eb7f006&scoped=true"
import script from "./TabMedicalReform.vue?vue&type=script&lang=js"
export * from "./TabMedicalReform.vue?vue&type=script&lang=js"
import style0 from "./TabMedicalReform.vue?vue&type=style&index=0&id=1eb7f006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb7f006",
  null
  
)

export default component.exports